export interface ContextMenuInterface {
  name: string;
  isEnabled: boolean;
  showTree: boolean;
  subTemplateObject?: Object;
  deletableSubTempRange?: Object;
  key?: string;
  sectionIdForUMC?: string;
  bulletListRange?: Object;
}
